module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle9.png?a188f01a235437fd0b56b35af9a9bb7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle9.png
// module id = 847
// module chunks = 0